
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome/accounts",
      function () {
        return require("private-next-pages/welcome/accounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welcome/accounts"])
      });
    }
  